import { TABLE_SECTIONS } from "../model/administrationConstants";

export const inputStyle = {
    width: "100%", boxSizing: "border-box", border: "1px solid #d1d5db", borderRadius: "6px",
    padding: "7px 8px", background: "white", color: "#111827", fontSize: "13px",
};

export const labelStyle = { display: "grid", gap: "5px", color: "#374151", fontSize: "12px", fontWeight: 600 };

export const toolbarStyle = { display: "flex", gap: "18px", alignItems: "center", flexWrap: "wrap", background: "white", padding: "16px", borderRadius: "10px", border: "1px solid #e5e7eb", marginBottom: "18px" };

export const importPanelStyle = {
    display: "grid", gap: "14px", background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: "12px",
    padding: "16px", marginBottom: "18px", boxShadow: "0 8px 20px rgba(21, 128, 61, 0.08)",
};

export const importControlsStyle = { display: "flex", gap: "12px", alignItems: "end", flexWrap: "wrap" };

export const importReportStyle = {
    display: "grid", gap: "5px", background: "white", border: "1px solid #dcfce7", borderRadius: "9px",
    padding: "12px", color: "#14532d", fontSize: "13px",
};

export const importIssuesStyle = { margin: "8px 0 0", paddingLeft: "18px", color: "#374151", display: "grid", gap: "4px" };

export const tabsBarStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "16px",
    flexWrap: "wrap",
    marginBottom: "18px",
};

export const tabsStyle = {
    display: "inline-flex", gap: "3px", padding: "3px",
    border: "1px solid #d1d5db", borderRadius: "7px", background: "#f1f5f9",
};

export const tabStyle = active => ({
    border: 0, borderRadius: "5px", padding: "8px 14px", cursor: "pointer",
    background: active ? "white" : "transparent", color: active ? "#111827" : "#64748b",
    fontWeight: active ? 700 : 600, boxShadow: active ? "0 1px 3px rgba(15, 23, 42, 0.12)" : "none",
});

export const viewToggleStyle = {
    display: "inline-flex",
    gap: "3px",
    padding: "3px",
    border: "1px solid #d1d5db",
    borderRadius: "7px",
    background: "#f1f5f9",
};

export const viewToggleButtonStyle = active => ({
    border: 0,
    borderRadius: "5px",
    width: "34px",
    height: "34px",
    padding: 0,
    background: active ? "white" : "transparent",
    color: active ? "#111827" : "#64748b",
    cursor: "pointer",
    fontWeight: active ? 700 : 600,
    fontSize: "18px",
    lineHeight: 1,
    boxShadow: active ? "0 1px 3px rgba(15, 23, 42, 0.12)" : "none",
});

export const tableContainerStyle = { overflow: "auto", maxHeight: "calc(100vh - 230px)", border: "1px solid #d1d5db", borderRadius: "10px", background: "white" };

export const tableStyle = { borderCollapse: "separate", borderSpacing: 0, minWidth: "4760px", width: "100%", fontSize: "13px" };

export const verticalWorkspaceStyle = {
    display: "grid",
    gridTemplateColumns: "minmax(220px, 280px) minmax(0, 1fr)",
    gap: "16px",
    alignItems: "start",
};

export const verticalSidebarStyle = {
    display: "grid",
    position: "sticky",
    top: "16px",
    alignSelf: "start",
    background: "white",
    border: "1px solid #e2e8f0",
    borderRadius: "14px",
    overflow: "hidden",
    boxShadow: "0 4px 16px rgba(15,23,42,.05)",
    maxHeight: "calc(100vh - 250px)",
};

export const verticalDetailStyle = {
    display: "grid",
    gap: "14px",
    background: "white",
    border: "1px solid #e5e7eb",
    borderRadius: "8px",
    padding: "16px",
};

export const verticalDetailHeaderStyle = {
    position: "sticky",
    top: 0,
    zIndex: 5,
    background: "white",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "14px",
    flexWrap: "wrap",
    paddingTop: "12px",
    paddingBottom: "12px",
    borderBottom: "1px solid #e5e7eb",
    boxShadow: "0 8px 18px rgba(15, 23, 42, 0.06)",
};

export const verticalActionsStyle = { display: "flex", gap: "8px", flexWrap: "wrap", justifyContent: "flex-end" };

export const verticalPatientIdentityStyle = { display: "grid", gridTemplateColumns: "minmax(0, 1fr) 32px", gap: "10px", alignItems: "start", minWidth: 0 };

export const patientNameWithBadgeStyle = { display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap", minWidth: 0 };

export const patientListNameWithBadgeStyle = { display: "flex", alignItems: "center", gap: "6px", minWidth: 0 };

export const patientHeaderControlsStyle = { display: "flex", alignItems: "end", gap: "10px", flexWrap: "wrap", marginTop: "10px" };

export const patientHeaderFieldStyle = { display: "grid", gap: "4px", color: "#64748b", fontSize: "11px", fontWeight: 800, minWidth: "150px" };

export const patientStatusBadgeStyle = {
    display: "inline-flex",
    alignItems: "center",
    width: "fit-content",
    padding: "2px 7px",
    borderRadius: "999px",
    background: "#e5e7eb",
    color: "#374151",
    border: "1px solid #d1d5db",
    fontSize: "10px",
    fontWeight: 800,
    textTransform: "uppercase",
    whiteSpace: "nowrap",
};

export const verticalSectionsStyle = { display: "grid", gap: "14px" };

export const verticalSectionStyle = section => ({
    border: `1px solid ${TABLE_SECTIONS[section]?.border || "#e5e7eb"}`,
    borderRadius: "8px",
    overflow: "hidden",
    background: TABLE_SECTIONS[section]?.cell || "white",
});

export const verticalSectionTitleStyle = section => ({
    margin: 0,
    padding: "10px 12px",
    background: TABLE_SECTIONS[section]?.header || "#334155",
    color: "white",
    fontSize: "14px",
});

export const verticalFieldsGridStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(210px, 1fr))",
    gap: "12px",
    padding: "12px",
};

export const administrationRowsStyle = {
    display: "grid",
    gap: "12px",
    padding: "12px",
};

export const administrationFieldsRowStyle = columnCount => ({
    display: "grid",
    gridTemplateColumns: `repeat(${columnCount}, minmax(0, 1fr))`,
    gap: "12px",
});

export const guardianContactFieldStyle = { display: "grid", gap: "8px", alignItems: "start" };

export const guardianContactSummaryWrapperStyle = { position: "relative", minWidth: 0 };

export const guardianContactSummaryStyle = {
    margin: 0,
    maxWidth: "100%",
    whiteSpace: "pre-wrap",
    overflowWrap: "anywhere",
    padding: "5px 7px",
    border: "1px solid #d1d5db",
    borderRadius: "6px",
    background: "white",
    color: "#334155",
    fontFamily: "inherit",
    fontSize: "11px",
    lineHeight: 1.25,
};

export const guardianContactDeleteButtonStyle = {
    position: "absolute",
    top: "4px",
    right: "4px",
    width: "24px",
    height: "24px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    border: "1px solid #fecaca",
    borderRadius: "6px",
    background: "#fff1f2",
    color: "#b91c1c",
    cursor: "pointer",
    padding: 0,
};

export const patientDocumentPanelStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "10px",
    padding: "0",
};

export const automaticDebitBlockStyle = {
    display: "grid",
    gap: "10px",
    padding: "10px 12px",
    border: "1px solid #ccfbf1",
    borderRadius: "8px",
    background: "#f8fffd",
};

export const patientDocumentEmptyStyle = {
    color: "#64748b",
    fontSize: "13px",
    lineHeight: 1.4,
};

export const verticalFieldStyle = { display: "grid", gap: "6px", alignContent: "start" };

export const verticalFieldLabelStyle = { color: "#374151", fontSize: "12px", fontWeight: 700 };

export const patientListHeaderStyle = { display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px", borderBottom: "1px solid #edf0f4" };

export const patientListBodyStyle = { padding: "8px", overflowY: "auto", maxHeight: "calc(100vh - 330px)" };

export const patientListItemStyle = { width: "100%", display: "flex", alignItems: "center", gap: "11px", border: 0, borderRadius: "10px", padding: "10px", background: "transparent", textAlign: "left", cursor: "pointer", marginBottom: "3px" };

export const patientListItemActiveStyle = { background: "#eef2ff", boxShadow: "inset 3px 0 0 #6366f1" };

export const miniAvatarStyle = { width: "34px", height: "34px", borderRadius: "10px", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700, fontSize: "11px", flexShrink: 0 };

export const patientListItemInactiveStyle = { background: "#dbeafe", boxShadow: "inset 4px 0 0 #2563eb" };

export const patientListItemBothInactiveAndNotInvoicedStyle = { background: "#fee2e2", boxShadow: "inset 4px 0 0 #dc2626" };

export const patientListItemStatusStyle = ({ active, inactive, notInvoiced }) => ({
    ...patientListItemStyle,
    ...(inactive || notInvoiced ? patientListItemInactiveStyle : {}),
    ...(inactive && notInvoiced ? patientListItemBothInactiveAndNotInvoicedStyle : {}),
    ...(active ? patientListItemActiveStyle : {}),
    ...(active && (inactive || notInvoiced) ? { background: "#dbeafe", boxShadow: "inset 4px 0 0 #2563eb, 0 0 0 1px #93c5fd" } : {}),
    ...(active && inactive && notInvoiced ? { background: "#fee2e2", boxShadow: "inset 4px 0 0 #dc2626, 0 0 0 1px #fca5a5" } : {}),
});

export const miniAvatarStatusStyle = ({ active, inactive, notInvoiced }) => ({
    ...miniAvatarStyle,
    background: inactive && notInvoiced ? "#dc2626" : inactive || notInvoiced ? "#2563eb" : active ? "#6366f1" : "#eef2ff",
    color: inactive || notInvoiced || active ? "white" : "#4f46e5",
});

export const dirtyDotStyle = { width: "8px", height: "8px", borderRadius: "50%", background: "#f59e0b", boxShadow: "0 0 0 3px #fef3c7", flexShrink: 0 };

export const mergeConflictFieldStyle = { margin: 0, padding: "12px", border: "1px solid #cbd5e1", borderRadius: "8px", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" };

export const mergeChoiceStyle = selected => ({ display: "flex", gap: "9px", padding: "10px", border: `1px solid ${selected ? "#6366f1" : "#e2e8f0"}`, borderRadius: "7px", background: selected ? "#eef2ff" : "white", cursor: "pointer", overflowWrap: "anywhere" });

export const reportEditRowStyle = { display: "grid", gap: "8px", padding: "12px", border: "1px solid #e2e8f0", borderRadius: "8px", background: "#f8fafc" };

export const eyebrowStyle = { color: "#6366f1", textTransform: "uppercase", letterSpacing: ".08em", fontSize: "10px", fontWeight: 800 };

export const noSelectionStyle = { minHeight: "320px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", textAlign: "center", border: "1px dashed #cbd5e1", borderRadius: "14px", background: "rgba(255,255,255,.65)", color: "#334155" };

export const creditTableContainerStyle = { overflow: "auto", border: "1px solid #d1d5db", borderRadius: "8px", background: "white" };

export const creditTableStyle = { borderCollapse: "collapse", width: "100%", minWidth: "980px", fontSize: "13px" };

export const creditHeaderStyle = {
    padding: "11px", textAlign: "left", color: "white", background: "#334155",
    borderRight: "1px solid #475569", whiteSpace: "nowrap",
};

export const creditCellStyle = {
    padding: "10px", verticalAlign: "top", borderRight: "1px solid #e2e8f0",
    borderBottom: "1px solid #e2e8f0", minWidth: "150px",
};

export const groupHeaderStyle = { position: "sticky", top: 0, zIndex: 4, background: "#1e293b", color: "white", padding: "10px", borderRight: "1px solid #475569", borderBottom: "1px solid #475569", textAlign: "center", whiteSpace: "nowrap" };

export const subHeaderStyle = { position: "sticky", top: "38px", zIndex: 3, background: "#334155", color: "white", padding: "9px", borderRight: "1px solid #475569", minWidth: "145px", maxWidth: "220px" };

export const stickyPatientHeaderStyle = { left: 0, zIndex: 6, minWidth: "210px" };

export const stickyPatientCellStyle = { position: "sticky", left: 0, zIndex: 2, background: "inherit", minWidth: "210px" };

export const patientIdentityStyle = { display: "grid", gridTemplateColumns: "1fr auto", gap: "10px", alignItems: "start" };

export const patientIdentityActionsStyle = { display: "flex", gap: "6px", alignItems: "center" };

export const patientDetailStyle = { display: "block", marginTop: "5px", color: "#64748b", fontSize: "12px" };

export const statusControlsStyle = { display: "grid", gap: "12px", marginTop: "2px" };

export const notInvoicedCheckboxStyle = checked => ({
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "11px 13px",
    border: `1px solid ${checked ? "#fca5a5" : "#d1d5db"}`,
    borderRadius: "8px",
    background: checked ? "#fef2f2" : "#f9fafb",
    color: checked ? "#b91c1c" : "#374151",
    cursor: "pointer",
});

export const statusCheckboxStyle = { width: "19px", height: "19px", margin: 0, accentColor: "#dc2626", cursor: "pointer" };
